import fetch from 'unfetch';
/**
 *
 * @param {*} barId the id of the bar
 * @returns
 */
const getComments = async (barId) => {
	const url = `/api/comments/get`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({
			barId: barId,
		}),
	});

	if (res.ok) {
		return { status: 'success', data: await res.json() };
	} else {
		console.log(await res.json());
		return { status: 'error', data: await res.json() };
	}
};
export default getComments;
